import { Pharmacy } from '@qmd-types/patient';
import apiClient from './apiClient';

export async function searchPharmacies(search: string): Promise<Pharmacy[]> {
  const { data } = await apiClient.get<Pharmacy[]>(
    `api/v1/pharmacies?Count=10&SearchValue=${search}`,
  );

  return data;
}
